import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { editUser, editPublisher } from '../../actions';
import getBrowserInfo from '../../utils/getBrowserInfo';
import getDeviceType from '../../utils/getDeviceType';
import getOrCreateDeviceIdentity from '../../utils/getOrCreateDeviceKey';
import config from '../../../config';
import { setItem, getItem } from '../../utils/localStorageFn';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity,
} from '../../utils/auth';
import { injectScript } from '../register/hook';

const useLoginHandler = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const getPublisherByDomain = async () => {
    /**
     * TODO - Only in development, do something else in production
     * @param - domain
     */
    const domain = getItem('domain');

    const userData = JSON.parse(getItem('userdata'));
    const { accessToken } = userData;

    try {
      const response = await fetch(
        `${config.ApiBaseUrl}/wordpress/get/${domain}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const json = await response.json();

      const { data, message, success } = json;

      if (!success)
        throw new Error(
          message ?? 'Something went wrong. failed to process request'
        );

      dispatch(editPublisher(data));
      setItem('publisherdata', JSON.stringify(data));

      if (!data.isKycComplete) {
        removeAuthToken();
        removeRefreshToken();
        removeDeviceIdentity();

        setItem('isloginflow', true);
        history.push('/accesskey');
      } else {
        await injectScript(history);
      }
    } catch (e) {
      removeAuthToken();
      removeRefreshToken();
      removeDeviceIdentity();
      console.log(e);
    }
  };

  const loginAdmin = async (pData) => {
    let browserInfo = {};

    if (window.navigator) {
      const { userAgent, platform } = window.navigator;
      browserInfo = {
        os: platform || 'unknown',
        userAgent,
        browser: getBrowserInfo(userAgent),
        type: getDeviceType(userAgent),
        deviceKey: getOrCreateDeviceIdentity(),
      };
    }

    const payload = {
      ...pData,
      ...browserInfo,
      accessToken: '',
      idToken: '',
      refreshToken: '',
      name: 'examples', //= > their brand name ex Times of India
    };

    try {
      const response = await fetch(
        `${config.ApiBaseUrl}/wordpress/loginAdmin`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
      const json = await response.json();

      const { data, message, success } = json;

      if (!success)
        throw new Error(
          message ?? 'Something went wrong. failed to process request'
        );

      setAuthToken(data.accessToken);
      setRefreshToken(data.refreshToken);
      setDeviceIdentity(data.deviceKey);

      dispatch(editUser(data.user));
      setItem('userdata', JSON.stringify(data));

      await getPublisherByDomain();
      return data;
    } catch (e) {
      console.log(e);
      throw new Error(
        e.message ?? 'Something went wrong. failed to process request'
      );
    }
  };

  const loginAdminController = (data) => {
    (async () => {
      try {
        await loginAdmin(data);
      } catch (e) {
        console.log(e);
        toast.error(e.message);
      }
    })();
  };

  return loginAdminController;
};

export default useLoginHandler;
